import axios from 'axios';

const vibeApi = axios.create({
  baseURL: 'https://api-vibe.qesh.ai',
//   baseURL: 'http://192.168.1.56:3331',
});

export default vibeApi;
